module.exports = __webpack_public_path__ + "img/GHS09.b1871c61.gif";